import { countryOptions } from '@liveauctioneers/caterwaul-components/lib/Forms';

const availableShippingCountryCodes = [
    'US',
    'CA',
    'AT',
    'BE',
    'HR',
    'CY',
    'CZ',
    'DK',
    'EE',
    'FI',
    'FR',
    'DE',
    'GR',
    'HU',
    'IE',
    'IT',
    'LV',
    'LT',
    'LU',
    'MT',
    'NL',
    'PL',
    'PT',
    'RO',
    'SK',
    'SL',
    'ES',
    'SE',
    'GB',
    'BG',
];

export const availableShippingCountryOptions = availableShippingCountryCodes.map((countryCode) =>
    // sometimes the chunk that contains the countryOptions doesnt get loaded properly
    (countryOptions || []).find(({ value }) => value === countryCode)
);
